// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-8ebb9fc1] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.fade-enter-active[data-v-8ebb9fc1], .fade-leave-active[data-v-8ebb9fc1] {
  transition: opacity 0.3s ease;
}
.fade-enter[data-v-8ebb9fc1], .fade-leave-to[data-v-8ebb9fc1] {
  opacity: 0;
}
.linked-icons[data-v-8ebb9fc1] {
  display: flex;
}
.linked-icons img[data-v-8ebb9fc1] {
  padding: 12px;
  height: var(--default-clickable-area);
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.7;
}
.linked-icons img[data-v-8ebb9fc1]:hover {
  opacity: 1;
}
.popovermenu[data-v-8ebb9fc1] {
  display: none;
}
.popovermenu.open[data-v-8ebb9fc1] {
  display: block;
}
li.collection-list-item[data-v-8ebb9fc1] {
  flex-wrap: wrap;
  height: auto;
  cursor: pointer;
  margin-bottom: 0 !important;
}
li.collection-list-item .collection-avatar[data-v-8ebb9fc1] {
  margin-top: 0;
}
li.collection-list-item form[data-v-8ebb9fc1], li.collection-list-item .collection-item-name[data-v-8ebb9fc1] {
  flex-basis: 10%;
  flex-grow: 1;
  display: flex;
}
li.collection-list-item .collection-item-name[data-v-8ebb9fc1] {
  padding: 12px 9px;
}
li.collection-list-item input[data-v-8ebb9fc1] {
  margin-top: 4px;
  border-color: var(--color-border-maxcontrast);
}
li.collection-list-item input[type=text][data-v-8ebb9fc1] {
  flex-grow: 1;
}
li.collection-list-item .error[data-v-8ebb9fc1] {
  flex-basis: 100%;
  width: 100%;
}
li.collection-list-item .resource-list-details[data-v-8ebb9fc1] {
  flex-basis: 100%;
  width: 100%;
}
li.collection-list-item .resource-list-details li[data-v-8ebb9fc1] {
  display: flex;
  margin-inline-start: var(--default-clickable-area);
  border-radius: 3px;
  cursor: pointer;
}
li.collection-list-item .resource-list-details li[data-v-8ebb9fc1]:hover {
  background-color: var(--color-background-dark);
}
li.collection-list-item .resource-list-details li a[data-v-8ebb9fc1] {
  flex-grow: 1;
  padding: 3px;
  max-width: calc(100% - 30px);
  display: flex;
}
li.collection-list-item .resource-list-details span[data-v-8ebb9fc1] {
  display: inline-block;
  vertical-align: top;
  margin-inline-end: 10px;
}
li.collection-list-item .resource-list-details span.resource-name[data-v-8ebb9fc1] {
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  vertical-align: top;
  white-space: nowrap;
  flex-grow: 1;
  padding: 4px;
}
li.collection-list-item .resource-list-details img[data-v-8ebb9fc1] {
  width: 24px;
  height: 24px;
}
li.collection-list-item .resource-list-details .icon-close[data-v-8ebb9fc1] {
  opacity: 0.7;
}
li.collection-list-item .resource-list-details .icon-close[data-v-8ebb9fc1]:hover, li.collection-list-item .resource-list-details .icon-close[data-v-8ebb9fc1]:focus {
  opacity: 1;
}
.should-shake[data-v-8ebb9fc1] {
  animation: shake-8ebb9fc1 0.6s 1 linear;
}
@keyframes shake-8ebb9fc1 {
0% {
    transform: translate(15px);
}
20% {
    transform: translate(-15px);
}
40% {
    transform: translate(7px);
}
60% {
    transform: translate(-7px);
}
80% {
    transform: translate(3px);
}
100% {
    transform: translate(0px);
}
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-0e169eff] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.collection-list[data-v-0e169eff] * {
  box-sizing: border-box;
}
.collection-list > li[data-v-0e169eff] {
  display: flex;
  align-items: center;
  gap: 12px;
}
.collection-list > li > .avatar[data-v-0e169eff] {
  margin-top: 0;
}
#collection-select-container[data-v-0e169eff] {
  display: flex;
  flex-direction: column;
}
.v-select span.avatar[data-v-0e169eff] {
  display: block;
  padding: 16px;
  opacity: 0.7;
  background-repeat: no-repeat;
  background-position: center;
}
.v-select span.avatar[data-v-0e169eff]:hover {
  opacity: 1;
}
p.hint[data-v-0e169eff] {
  z-index: 1;
  margin-top: -16px;
  padding: 8px 8px;
  color: var(--color-text-maxcontrast);
  line-height: normal;
}
div.avatar[data-v-0e169eff] {
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 8px;
  background-color: var(--color-background-dark);
  margin-top: 30px;
}

/** TODO provide white icon in core */
.icon-projects[data-v-0e169eff] {
  display: block;
  padding: 8px;
  background-repeat: no-repeat;
  background-position: center;
}
.option__wrapper[data-v-0e169eff] {
  display: flex;
}
.option__wrapper .avatar[data-v-0e169eff] {
  display: block;
  width: 32px;
  height: 32px;
  background-color: var(--color-background-darker) !important;
}
.option__wrapper .option__title[data-v-0e169eff] {
  padding: 4px;
}
.fade-enter-active[data-v-0e169eff], .fade-leave-active[data-v-0e169eff] {
  transition: opacity 0.5s;
}
.fade-enter[data-v-0e169eff], .fade-leave-to[data-v-0e169eff] {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcCollectionList-e5JFvzqX.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,kDAAkD;EAClD,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,uCAAuC;AACzC;AACA;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2DAA2D;AAC7D;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-8ebb9fc1] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.fade-enter-active[data-v-8ebb9fc1], .fade-leave-active[data-v-8ebb9fc1] {\n  transition: opacity 0.3s ease;\n}\n.fade-enter[data-v-8ebb9fc1], .fade-leave-to[data-v-8ebb9fc1] {\n  opacity: 0;\n}\n.linked-icons[data-v-8ebb9fc1] {\n  display: flex;\n}\n.linked-icons img[data-v-8ebb9fc1] {\n  padding: 12px;\n  height: var(--default-clickable-area);\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  opacity: 0.7;\n}\n.linked-icons img[data-v-8ebb9fc1]:hover {\n  opacity: 1;\n}\n.popovermenu[data-v-8ebb9fc1] {\n  display: none;\n}\n.popovermenu.open[data-v-8ebb9fc1] {\n  display: block;\n}\nli.collection-list-item[data-v-8ebb9fc1] {\n  flex-wrap: wrap;\n  height: auto;\n  cursor: pointer;\n  margin-bottom: 0 !important;\n}\nli.collection-list-item .collection-avatar[data-v-8ebb9fc1] {\n  margin-top: 0;\n}\nli.collection-list-item form[data-v-8ebb9fc1], li.collection-list-item .collection-item-name[data-v-8ebb9fc1] {\n  flex-basis: 10%;\n  flex-grow: 1;\n  display: flex;\n}\nli.collection-list-item .collection-item-name[data-v-8ebb9fc1] {\n  padding: 12px 9px;\n}\nli.collection-list-item input[data-v-8ebb9fc1] {\n  margin-top: 4px;\n  border-color: var(--color-border-maxcontrast);\n}\nli.collection-list-item input[type=text][data-v-8ebb9fc1] {\n  flex-grow: 1;\n}\nli.collection-list-item .error[data-v-8ebb9fc1] {\n  flex-basis: 100%;\n  width: 100%;\n}\nli.collection-list-item .resource-list-details[data-v-8ebb9fc1] {\n  flex-basis: 100%;\n  width: 100%;\n}\nli.collection-list-item .resource-list-details li[data-v-8ebb9fc1] {\n  display: flex;\n  margin-inline-start: var(--default-clickable-area);\n  border-radius: 3px;\n  cursor: pointer;\n}\nli.collection-list-item .resource-list-details li[data-v-8ebb9fc1]:hover {\n  background-color: var(--color-background-dark);\n}\nli.collection-list-item .resource-list-details li a[data-v-8ebb9fc1] {\n  flex-grow: 1;\n  padding: 3px;\n  max-width: calc(100% - 30px);\n  display: flex;\n}\nli.collection-list-item .resource-list-details span[data-v-8ebb9fc1] {\n  display: inline-block;\n  vertical-align: top;\n  margin-inline-end: 10px;\n}\nli.collection-list-item .resource-list-details span.resource-name[data-v-8ebb9fc1] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  position: relative;\n  vertical-align: top;\n  white-space: nowrap;\n  flex-grow: 1;\n  padding: 4px;\n}\nli.collection-list-item .resource-list-details img[data-v-8ebb9fc1] {\n  width: 24px;\n  height: 24px;\n}\nli.collection-list-item .resource-list-details .icon-close[data-v-8ebb9fc1] {\n  opacity: 0.7;\n}\nli.collection-list-item .resource-list-details .icon-close[data-v-8ebb9fc1]:hover, li.collection-list-item .resource-list-details .icon-close[data-v-8ebb9fc1]:focus {\n  opacity: 1;\n}\n.should-shake[data-v-8ebb9fc1] {\n  animation: shake-8ebb9fc1 0.6s 1 linear;\n}\n@keyframes shake-8ebb9fc1 {\n0% {\n    transform: translate(15px);\n}\n20% {\n    transform: translate(-15px);\n}\n40% {\n    transform: translate(7px);\n}\n60% {\n    transform: translate(-7px);\n}\n80% {\n    transform: translate(3px);\n}\n100% {\n    transform: translate(0px);\n}\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-0e169eff] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.collection-list[data-v-0e169eff] * {\n  box-sizing: border-box;\n}\n.collection-list > li[data-v-0e169eff] {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.collection-list > li > .avatar[data-v-0e169eff] {\n  margin-top: 0;\n}\n#collection-select-container[data-v-0e169eff] {\n  display: flex;\n  flex-direction: column;\n}\n.v-select span.avatar[data-v-0e169eff] {\n  display: block;\n  padding: 16px;\n  opacity: 0.7;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.v-select span.avatar[data-v-0e169eff]:hover {\n  opacity: 1;\n}\np.hint[data-v-0e169eff] {\n  z-index: 1;\n  margin-top: -16px;\n  padding: 8px 8px;\n  color: var(--color-text-maxcontrast);\n  line-height: normal;\n}\ndiv.avatar[data-v-0e169eff] {\n  width: 32px;\n  height: 32px;\n  margin: 0;\n  padding: 8px;\n  background-color: var(--color-background-dark);\n  margin-top: 30px;\n}\n\n/** TODO provide white icon in core */\n.icon-projects[data-v-0e169eff] {\n  display: block;\n  padding: 8px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.option__wrapper[data-v-0e169eff] {\n  display: flex;\n}\n.option__wrapper .avatar[data-v-0e169eff] {\n  display: block;\n  width: 32px;\n  height: 32px;\n  background-color: var(--color-background-darker) !important;\n}\n.option__wrapper .option__title[data-v-0e169eff] {\n  padding: 4px;\n}\n.fade-enter-active[data-v-0e169eff], .fade-leave-active[data-v-0e169eff] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-0e169eff], .fade-leave-to[data-v-0e169eff] {\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
